export default "__VITE_ASSET__CiwfvpRv__"